import clsx from "clsx";

import { CustomProxyForm } from "common/components/Proxy";
import { Dialog, DialogContent } from "common/components/ui/Dialog";
import type { CustomProxy } from "common/types";

import DeleteProxy from "./DeleteProxy";

import type { JSX } from "react";

interface ProxyDialogProps {
  proxy: CustomProxy;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  action: "edit" | "delete";
}

export default function ProxyDialog({
  proxy,
  isOpen,
  setIsOpen,
  action,
}: ProxyDialogProps) {
  let component: JSX.Element;

  if (action === "delete") {
    component = (
      <DeleteProxy
        proxy={proxy}
        onBack={() => setIsOpen(false)}
        onSuccess={() => setIsOpen(false)}
      />
    );
  } else if (action === "edit") {
    component = (
      <CustomProxyForm proxy={proxy} onBack={() => setIsOpen(false)} />
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent
        className={clsx(
          "max-h-[90%] overflow-auto",
          action === "delete" && "lg:w-[448px]",
        )}
      >
        {component}
      </DialogContent>
    </Dialog>
  );
}
